import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

export default function BassinFace() {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "bassin_face.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Img
      fluid={data.file.childImageSharp.fluid}
      alt="Une séance d'activité de l'enfant d'eau de face"
      className="shadow-lg rounded-lg my-8"
    />
  );
}
